<template>
	<div
		v-bind:style="{ backgroundImage: 'url(' + welcomeBG() + ')' }"
		id="welcome"
	>
		<div v-if="!currentPicker" class="startPanel">
			<div class="topHeading">{{ $t("startTop") }}</div>
			<div class="heading">{{ $t("startTitle") }}</div>
			<div class="text">
				{{ $t("startText") }}
			</div>
			<div v-on:click="start" class="startButton button white adapted">
				{{ $t("startButton") }}
			</div>
		</div>
	</div>
</template>

<script>

export default {

	data: function(){
		return{
			wgURL: window.appSettings.wgURL,
		}
	},

  methods: {
  	start(){
  		window.eventHub.$emit('openPicker', 'backgrounds');
  	},

  	welcomeBG(){

  		var requiredWidth = this.pictureWallWidth();

  		if(!requiredWidth)
            var url = this.wgURL + '/general/welcome-bg.jpg'

        // If transformed image use cloudinary to get correct size
        else
        	var url = window.appSettings.getResizedImageFromCloud(requiredWidth, 'welcome-bg.jpg?v=1', 'backgrounds/');

        return url;
  	}

  }

}
</script>

<style lang="scss">
	#welcome {
		background-size: cover;
		background-position: center center;
		height: 100%;
		width: 100%;

		.startPanel {
			background: rgba(0, 0, 0, 0.69);
			color: white;
			position: absolute;
			max-width: 700px;
			width: 100%;
			top: 50%;
			left: 50%;
			text-align: center;
			padding: 62px;
			transform: translate(-50%, -50%);

			/* Mobile */
			@media screen and (max-width: 844px) {
				max-width: 90%;
				padding: 19px 5px;
				top: 50%;
			}
		}

		.topHeading {
			font-size: 17px;
			text-transform: uppercase;
			font-weight: 100;
			font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
			margin-bottom: 8px;
			letter-spacing: 1px;

			/* Mobile */
			@media screen and (max-width: 844px) {
				margin-bottom: 4px;
				font-size: 18px;
			}
		}

		.heading {
			font-family: "Fanwood+Text";
			font-style: italic;
			font-size: 26px;
			font-weight: 100;
			margin-bottom: 14px;
			letter-spacing: 1px;

			/* Mobile */
			@media screen and (max-width: 844px) {
				margin-bottom: 14px;
				font-size: 20px;
			}
		}

		.text {
			font-size: 15px;
			max-width: 76%;
			margin: auto;

			/* Mobile */
			@media screen and (max-width: 844px) {
				font-size: 13px;
			}
		}

		.startButton {
			margin-top: 27px;
			font-size: 14px;
			padding: 12px 33px;
			font-weight: bold;

			/* Mobile */
			@media screen and (max-width: 844px) {
				font-size: 12px;
				padding: 10px 30px;
			}
		}

		@media (max-width: 844px) and (max-height: 250px) {
			.topHeading {
				margin-bottom: 0;
				margin-top: 10px;
			}

			.heading {
				margin-bottom: 7px;
			}

			.startButton {
				margin-top: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Welcome.vue?362e7790